<div class="form-container">
  <div class="form-header">
    <div>
      <h3>Employee Login</h3>
      <h4 *ngIf="type == 'in'">Job In Details</h4>
      <h4 *ngIf="type == 'out'">Job Out Details</h4>
    </div>
  </div>

  <div class="form-card">
    <!-- Barcode Scan Input -->
    <div class="form-row">
      <mat-form-field appearance="fill" class="form-field-md">
        <mat-label>Scan Employee Barcode</mat-label>
        <input #barcodeInput matInput type="text" autocomplete="off"
               [(ngModel)]="barcodeValue"
               (keydown)="onBarcodeScan($event)"
               placeholder="Scan barcode..."
               [disabled]="scanningInProgress"
               name="barcode_scan">
        <mat-icon matPrefix>qr_code_scanner</mat-icon>
        <mat-hint>Scan employee badge barcode to login instantly</mat-hint>
      </mat-form-field>
    </div>

    <div class="divider-row">
      <span class="divider-text">OR</span>
    </div>

    <!-- Existing dropdown + PIN flow -->
    <div class="form-row">
      <mat-form-field appearance="fill" class="form-field-md">
        <mat-label>Employee Name</mat-label>
        <mat-select #employee_select (openedChange)="onEmployeeScroll($event)" [(value)]="selectedEmployee" placeholder="Select Employee">
          <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="onEmployeeKey($event)" matInput name="employee_list">
          <mat-option *ngFor="let employee of allEmployees" [value]="employee.id">{{employee.name}}</mat-option>
        </mat-select>
        <mat-icon matPrefix>badge</mat-icon>
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field appearance="fill" class="form-field-md">
        <mat-label>4 Digit Security Key</mat-label>
        <input (keypress)="keyPress($event)" placeholder="Enter security key" autocomplete="off" type="password" matInput name="password" maxlength="4">
        <mat-icon matPrefix>lock</mat-icon>
      </mat-form-field>
    </div>
  </div>
</div>